import React, {useEffect, useState} from "react";
import { Form, Button, Row, Col, Container } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import {FormField, FormPayload} from "../../../../service/types/types";
import { FormsService } from "../../../../service/forms.service";
import { FeedbackModal } from "../../../common/feedback.modal";
import {DistributionsService} from "../../../../service/distributionList.service";
import Select from "react-select";
import FormFieldsEditorMail from "./formFieldsEditorMail";

export default function FormBuilderMail() {
  const [formName, setFormName] = useState("");
  const [isSignRequired, setIsSighnRequired] = useState(false);
  const [fields, setFields] = useState<FormField[]>([]);

  //modal
  const [showModal, setShowModal] = useState(false);
  const [emailGroups, setEmailGroups] = useState<string[]>([]);
  const [modalType, setModalType] = useState<"success" | "error">("success");
  const [modalMessage, setModalMessage] = useState("");
  const [distributionLists, setDistributionLists] = useState<{ value: string; label: string; }[]>([]);

  useEffect(() => {
    const getDistributionLists = async () => {
      const dl = await DistributionsService.findAll("arauco");
      const options = dl.map(distributionList => ({
        value: distributionList.id,
        label: `${distributionList.name}`,
      }));
      setDistributionLists(options);
    };
    getDistributionLists();
  },[])

  const updateFormMails = (value: any) => {
    value = value ? value.map((option: any) => option.value) : [];
    setEmailGroups(value);
  };

  const saveForm = async () => {
    if(formName == null || formName === "") {
      alert("nombre del formulario vacio");
      return;
    }
    else if(fields.length === 0){
      alert("ingrese al menos un campo");
      return;
    }
    const payload: FormPayload = {
      id: uuidv4(),
      name: formName,
      organization: 'arauco',
      isSignRequired,
      fields,
      distributionList: emailGroups,
    };
    try{
      await FormsService.create({ ...payload});
      onSave(true);
    } catch (error: any) {
      onSave(false);
    }
  };
  
  const onSave = (isOk: boolean) => {
    if (isOk) {
      setModalType("success")
      setModalMessage("Lista Control Guardada Correctamente")
    } else {
      setModalType("error")
      setModalMessage("Error Guardado Lista Control")
    }
    setShowModal(true);
  };

  // @ts-ignore
  return (
    <Container fluid className="p-4">

      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
        autoClose={true}   // 👈 se cierra solo en 3s
        duration={3000}
      />
      <h3>Crear Lista de Control</h3>
      <Form>
        <Form.Group className="mb-3 w-100">
          <Form.Label>Nombre Lista de Control</Form.Label>
          <Form.Control
            type="text"
            value={formName}
            required={true}
            onChange={e => setFormName(e.target.value)}
            placeholder="Ej: Encuesta de satisfacción"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="isSignRequired">
          <Form.Check
            type="checkbox"
            label="¿Requiere firma?"
            name="isSignRequired"
            checked={isSignRequired}
            onChange={e => setIsSighnRequired(!isSignRequired)}
          />
        </Form.Group>
        <FormFieldsEditorMail fields={fields} onChange={setFields} distributionLists={distributionLists} />
        <Row className="mt-2">
            <Col md={12}>
              <Select
                  options={distributionLists}
                  onChange={(options) => updateFormMails(options)}
                  className="w-100"
                  isMulti
                  placeholder="lista de distribución..."
                  isSearchable
              />
            </Col>
        </Row>
        <br/>
        <Button variant="success" onClick={saveForm}>
          Guardar Formulario
        </Button>
      </Form>
      <br/>
    </Container>
  );
}